import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
import MainEnLayout from '../layouts/MainEnLayout.vue'
import MainJaLayout from '../layouts/MainJaLayout.vue'
import loadMarkdownFiles from "@/utils/loadMarkdown";
import loadMarkdownEnFiles from "@/utils/loadMarkdownEn";
import loadMarkdownJaFiles from "@/utils/loadMarkdownJa";

// 只加载一次文件列表
const files = loadMarkdownFiles();
const enFiles = loadMarkdownEnFiles();
const jaFiles = loadMarkdownJaFiles();

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: '/wiki/default'
        },
        {
          path: 'wiki/:path(.*)',
          name: 'docs',
          component: () => import('../views/MarkdownView.vue')
        }
      ]
    },
    {
      path: '/en',
      component: MainEnLayout,
      children: [
        {
          path: '',
          redirect: '/en/default'
        },
        {
          path: ':path(.*)',
          name: 'docs-en',
          component: () => import('../views/MarkdownEnView.vue')
        }
      ]
    },
    {
      path: '/ja',
      component: MainJaLayout,
      children: [
        {
          path: '',
          redirect: '/ja/default'
        },
        {
          path: ':path(.*)',
          name: 'docs-ja',
          component: () => import('../views/MarkdownJaView.vue')
        }
      ]
    }
  ]
})

// 路由守卫，处理默认路径
router.beforeEach((to, from, next) => {
  if (to.path === '/wiki/default') {
    if (files.length > 0) {
      // 确保路径不以点号开头
      const path = files[0].path;
      next(`/wiki${path}`);
    } else {
      next();
    }
    return
  } 

  console.log("beforeEach=======", to.path)

  if (to.path === '/en' || to.path === '/en/' || to.path === '/en/default') {
    if (enFiles.length > 0) {
      // 确保路径不以点号开头
      const path = enFiles[0].path;
      next(`/en${path}`);
    } else {
      next();
    }
    return
  } 

  if (to.path === '/ja' || to.path === '/ja/' || to.path === '/ja/default') {
    if (jaFiles.length > 0) {
      // 确保路径不以点号开头
      const path = jaFiles[0].path;
      next(`/ja${path}`);
    } else {
      next();
    }
    return
  } 

  next();
})

export default router 